<template>
    <ContentPage title="Tarification – Acheteur">
        <div>
            <p>
                Sauf accord écrit contraire ou disposition spécifique dans les conditions particulières de la vente aux enchères, les commissions dues
                par l’acheteur à Fleequid pour la vente de chaque véhicule réalisée ou les services et systèmes de vente de Fleequid sont les
                suivantes :
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> hors TVA</p>
            <p><strong>**</strong> + TVA si applicable</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Exemple 1:</p>
            <p>Prix de cession: 6.000&nbsp;€ +&nbsp;TVA</p>
            <p>
                Commission due à Fleequid par l'acheteur: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;TVA</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Exemple 2:</p>
            <p>Prix de cession: 180.000&nbsp;€ +&nbsp;TVA</p>
            <p>
                Commission due à Fleequid par l'acheteur: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;TVA</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
